import * as Sentry from '@sentry/react';
import { generateUniqueSentryInviteId } from './generateId';

export const setSentryUser = (user, guestId) => {
  let ID;
  try {
    if (user && user._id) {
      Sentry.setUser({ id: user._id });
      ID = user._id;
    } else if (guestId) {
      Sentry.setUser({ guestId: guestId, isGuest: true });
      ID = guestId;
    } else {
      const inviteId = generateUniqueSentryInviteId();
      Sentry.setUser({ id: inviteId, isGuest: true, isErrorRecovery: true });
      localStorage.setItem('guestId', inviteId);
      ID = inviteId;
    }
    return ID;
  } catch (error) {
    const fallbackId = generateUniqueSentryInviteId();
    localStorage.setItem('guestId', fallbackId);
    ID = fallbackId;
    console.log(error);
    return ID;
  }
};
